import { Text, useDisclosure } from '@chakra-ui/core'
import LocaleText from 'components/LocaleText'
import TaskCreationModal from 'components/TasksV2/TaskCreation/TaskCreationModal'
import React from 'react'
import { SquareCheckBig } from 'lucide-react'
import { ActionButton, IconBlock } from './NavMenu'

export const CreateTaskV2Button: React.FC<{ setIsHidden?: (hide: boolean) => void }> = ({ setIsHidden }) => {
  const { isOpen: isOpenCreateTask, onOpen: onOpenCreateTask, onClose: onCloseCreateTask } = useDisclosure()

  const handleOpenTaskCreationModal = () => {
    setIsHidden?.(true)
    onOpenCreateTask()
  }

  const handleCloseTaskCreationModal = () => {
    setIsHidden?.(false)
    onCloseCreateTask()
  }

  return (
    <>
      <ActionButton onClick={handleOpenTaskCreationModal}>
        <IconBlock bg="#E0E7FF" borderRadius="10px" color="white" alignItems="center" justifyContent="center">
          <SquareCheckBig size={18} color="#4F46E5" />
        </IconBlock>
        <Text fontSize="14px">
          <LocaleText text="create_task_btn" />
        </Text>
      </ActionButton>
      {isOpenCreateTask && <TaskCreationModal isOpen={isOpenCreateTask} onClose={handleCloseTaskCreationModal} />}
    </>
  )
}
